/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

export const googleMapsKey = 'AIzaSyAnWJSarkqgNTx5ocG3PjsFUKrCNCuAnaQ';
export const autoUpdate = true;
export const baiduMap = true;
export const i18nBackendLoadPath = '/locales/{{lng}}/{{ns}}.json';
export const baseURL = 'https://api.soundtalks.cn';
export const captchaKey = '0x4AAAAAAAC1jBPUWkZ704Z9';
export const isChinaConfig = true;
export const reversedFullName = true;
export const apkDownloadUrl = 'https://apk.soundtalks.cn/';
export const wechatAppId = 'wx6754d7df320c7e03';
// Allowed domains for pre-signed download URLs
export const allowedDownloadDomains = [
  'soundtalks-prdcn-s3-backend-batch-exports.s3.cn-northwest-1.amazonaws.com.cn', // Batch exports
  'audio.soundtalks.cn', // Audio snippets
];
